import { fromJS } from 'immutable'
import {
  COMPENSATE_REQUEST_CREATE_REQUEST,
  COMPENSATE_REQUEST_CREATE_SUCCESS,
  COMPENSATE_REQUEST_CREATE_FAILURE,
  COMPENSATE_REQUEST_CREATE_RESET,
} from '../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case COMPENSATE_REQUEST_CREATE_REQUEST:
      return state
        .set('isFetching', true)
    case COMPENSATE_REQUEST_CREATE_SUCCESS:
      return state
        .set('createdCompensate', fromJS(action.payload.createdCompensate))
        .set('status', 200)
        .set('message', 'Created Successfully.')
        .set('isFetching', false)
    case COMPENSATE_REQUEST_CREATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('createdCompensate', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case COMPENSATE_REQUEST_CREATE_RESET:
      return state
        .delete('createdCompensate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/compensate-request/compensate-request-create-reducer.js